import { useQuery } from './query';

export function useTravelerInterest({
  dispatch,
  getTravelerInterest,
  integrationSettings,
  prePopulation,
  meta,
  pageContext,
  selectedItems
}) {
  const getData = () => {
    return getTravelerInterest(prePopulation, integrationSettings, meta, pageContext)
      .then((data) => {
        return data;
      })
      .catch((err) => {
        throw err;
      });
  };

  const travelersInterest = useQuery({ getData }, [
    integrationSettings,
    prePopulation.travelerInterest,
    meta,
    getTravelerInterest
  ]);

  const onChange = (payload) => {
    dispatch({
      type: 'TRAVELER_CHANGE',
      payload
    });
  };

  const onClear = (payload) => {
    dispatch({
      type: 'TRAVELER_CLEAR',
      payload
    });
  };

  return {
    travelersInterest,
    selectedItems,
    onChange,
    onClear
  };
}
